import { WellpassImportDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';
import { useMemo } from 'react';

interface WellpassSettingsReturnType {
  data: WellpassImportDTO | undefined;
  isLoading: boolean;
  refetch: () => void;
}

export const useWellpassSettings = (): WellpassSettingsReturnType => {
  const { data, isLoading, refetch } = useTenantQuery([apis.wellpass.getWellpassConfig.name], tenantId =>
    apis.wellpass.getWellpassConfig({ tenantId }).then(res => res.data),
  );
  return useMemo(() => ({ data, isLoading, refetch }), [data, isLoading, refetch]);
};
